import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DesktopFooterComponent } from './desktop-footer/desktop-footer.component';
import { MobileFooterComponent } from './mobile-footer/mobile-footer.component';
import { StayInTouchComponent } from './stay-in-touch/stay-in-touch.component';
import { ShellService } from '../shell.service';

@Component({
  selector: 'ss-www-footer',
  imports: [
    CommonModule,
    DesktopFooterComponent,
    MobileFooterComponent,
    StayInTouchComponent,
  ],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  lastItemBgClass = inject(ShellService).lastItemBgClass;

  constructor() {}
}
